import React from 'react';
import './StatCard.css';

const StatCard = ({ icon, title, value, change, color = 'primary', prefix = '', suffix = '' }) => {
  const isPositive = change && change > 0;

  return (
    <div className="stat-card glass-card">
      <div className="stat-icon-wrapper">
        <div className={`stat-icon stat-icon-${color}`}>
          <i className={`bi ${icon}`}></i>
        </div>
        <div className="stat-glow"></div>
      </div>

      <div className="stat-content">
        <h6 className="stat-title">{title}</h6>
        <div className="stat-value">
          {prefix}
          <span className="counter" data-value={value}>
            {value.toLocaleString()}
          </span>
          {suffix}
        </div>
        {change !== undefined && (
          <div className={`stat-change ${isPositive ? 'positive' : 'negative'}`}>
            <i className={`bi bi-arrow-${isPositive ? 'up' : 'down'}`}></i>
            {Math.abs(change)}%
          </div>
        )}
      </div>

      <div className="stat-chart">
        <svg viewBox="0 0 100 40" className="mini-chart">
          <polyline
            points="0,35 20,25 40,30 60,20 80,25 100,15"
            fill="none"
            stroke={isPositive ? '#00FF95' : '#ff3b30'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <linearGradient id={`gradient-${color}`} x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor={isPositive ? '#00FF95' : '#ff3b30'} stopOpacity="0.3" />
            <stop offset="100%" stopColor={isPositive ? '#00FF95' : '#ff3b30'} stopOpacity="0" />
          </linearGradient>
          <polyline
            points="0,35 20,25 40,30 60,20 80,25 100,15 100,40 0,40"
            fill={`url(#gradient-${color})`}
          />
        </svg>
      </div>
    </div>
  );
};

export default StatCard;